import { Dayjs } from 'dayjs';
import dayjs from './dayjs';

export function isMonthWithShortName(date: Date): boolean {
  const monthsWithShortName = [4, 5, 6];
  const month = date.getUTCMonth();
  return monthsWithShortName.some(m => m === month);
}
/** PROM-830
To keep previous logic, don’t show time under the following situation:
- If time is not set for a date (so it translates to 00:00)  
- if users set 00:00 for a date
**/
export function showTimeInDeadline(date: Dayjs | Date | null): boolean {
  if (!date) {
    return false;
  }
  if (date instanceof Date) {
    date = dayjs(date);
  }
  if (!date.isUTC()) {
    date = date.utc();
  }
  return !!(date.hour() || date.minute() || date.second() || date.millisecond());
}
